export const CreateTask = {
  state: {
    showCreateTask: false
  },
  mutations: {
    setShowCreateTask (state, payload) {
      state.showCreateTask = payload
    }
  },
  actions: {
    showCreateTask ({commit}) {
      commit("setShowCreateTask", true)
    },
    closeCreateTask ({commit}) {
      commit("setShowCreateTask", false)
    },
    toggleCreateTask ({commit, state}) {
      commit('setShowCreateTask', !state.showCreateTask)
    }
  },
  getters: {
    getShowCreateTask (state) {
      return state.showCreateTask
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/CreateTask.js